import React, { useEffect, useState } from "react";
import OfficeImage from "../../assets/img/office img.jpeg";
import { getImageUrl } from "../../services/apiServices";
import axios from "axios";
import { generateImage } from "../../utils/common-function";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ItemOfficeSpace = ({
  title,
  address,
  id,
  price,
  area,
  image,
  setSelectedItems,
  data,
  selectedItems,
  setSelectedISOICode,
  iso_code
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [favourite, setFavourite] = useState(false);

  const [imageUrl, setImageUrl] = useState("");

  const handleSelect = (select) => {
    if (select) {
      setFavourite(true);
      setSelectedItems((prev) => [...prev, id]);
      setSelectedISOICode((prev) => [...prev, iso_code])
    } else {
      setFavourite(false);
      setSelectedItems((prev) => prev.filter((item) => item !== id));
      setSelectedISOICode((prev) => prev.filter((item) => item !== iso_code))

    }
  };

  const onPreview = (item) => {
    // https://www.officerentinfo.ro/api/get-property-redirect/15923
    if (!item || !item?.id || !item?.country?.iso_code) {
      return "";
    } else {
      let countryCode =
        item.country.iso_code == "HR"
          ? `com.${item.country.iso_code}`
          : item.country.iso_code;
      let propertyId = item.id;
      const uri = `https://www.officerentinfo.${countryCode}/api/get-property-redirect/${propertyId}`;
      // Open the URL in a new tab
      window.open(uri, "_blank");
    }
  };
  return (
    <div className="bg-[#F4F4F4] md:flex gap-6 p-3 border border-[#C0C0C0] rounded-[32px]">
      <div>
        <div className="md:max-w-[255px]" style={{ aspectRatio: 1.335 }}>
          <img
            src={image ? image : OfficeImage}
            alt=""
            className="w-full h-full object-cover rounded-[20px]"
          />
        </div>
      </div>

      <div className="flex flex-col mt-3 md:mt-0 justify-center w-full">
        <div className="flex gap-4 justify-between">
          <div>
            <h3 className="text-primary-text font-semibold text-2xl">
              {title}
            </h3>
            <p className="text-[#5D5D5D] text-lg font-medium mt-2">{address}</p>
          </div>
          <div>
            <button onClick={() => handleSelect(!favourite)}>
              {favourite ? (
                <i class="fi fi-ss-heart text-3xl text-secondary"></i>
              ) : (
                <i class="fi fi-rs-heart text-3xl text-[#BABABA] "></i>
              )}
            </button>
          </div>
        </div>

        <div className="mt-5 flex md:flex-row flex-col gap-3 md:gap-0 justify-between">
          <div className="flex flex-wrap gap-5">
            <div className="flex gap-2 items-center">
              {/* <i class="fi fi-rr-euro-circletext-xl text-[#5D5D5D] mt-1"></i> */}
              {price ? (
                <>
                  <i class="fas fa-euro-sign text-xl text-[#5D5D5D] mt-1"></i>
                  <p className="text-[#5D5D5D] text-lg font-medium">{price}</p>
                </>
              ) : (
                ""
              )}
            </div>

            <div className="flex gap-2 items-center">
              {area ? (
                <>
                  <i class="fi fi-rr-expand-arrows text-lg text-[#5D5D5D] mt-1"></i>
                  <p className="text-[#5D5D5D] text-lg font-medium">{area}</p>
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          <button
            className="border border-[#C0C0C0] text-primary-text font-semibold rounded-[58px] py-1 px-4"
            onClick={() => onPreview(data)}
          >
            {t("office_space_preview")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemOfficeSpace;
